const urls = Object.freeze({
	incomingCall: {
		url: () => `/v1/incoming-call`,
		detail: {
			url: (incomingCallId = ':incomingCallId') => `${urls.incomingCall.url()}/${incomingCallId}`,
		},
	},
} as const);

export { urls };
